'use strict';
import Viewports from '../../fsUtils/Viewports';

/* Story Scroll V2 Factory */

angular.module('storyApp').factory('storyScroll', ['storyInView', function ( storyInView ) {

    var storyScroll = {

        onChangeStory: null,
        articleElements: [],
        isScrollDisabled: false,
        callbackQueue: [],
        globalNavH: 45,
        viewports: new Viewports(),

        //this will be used when other callbacks are hooked to the storyScroll onScroll event
        addToQueue: function(callbackFunc) {

            if (typeof callbackFunc === 'function') {

                this.callbackQueue.push(callbackFunc);
            }

        },

        init: function() {

            var that = this;

            that.startScroll();
            
            for (var i = 0; i < 4; i++) {
                that.articleElements.push(document.getElementById('story-' + (i + 1)));
            } 
        },

        /**
         * @desc make element position correctly after calling scrollIntoView when there is a fix position element on the page
         * @param Object el - dom object
         * @param Number num - positive or negative number
         * adding a positive num makes scrolling down; add a negative num makes scrolling backup
         */
        updateElScrollTop: function (el, num) {
            var re=/html$/i;
            while(!re.test(el.tagName) && (1 > el.scrollTop)) {
                el=el.parentNode;
            }
            if(0 <=  el.scrollTop) {
                el.scrollTop += num;
                return num;  //return the number that is added;
            }

        },

        getNavHeightOffset: function() {
            var Offset = this.globalNavH;
            var viewPort = this.viewports.getViewPort();

            if(viewPort !== 'mobile') {
                if (document.getElementById("wisss")) {
                    Offset += 75;
                }
            }

            return Offset;
        },

        /**
         * @desc event triggered by click on storyCtrl.js and route change on routeCtrl.js
         * @param Object elId - dom object
         * @param Number timer - pass 0 or 300 millisecond delay to start scrollIntoView
         * @param Bootlean fromClick - true or false
         */
        jumpToElement: function(elId, timer, fromClick){

            var that = this,
                el = document.getElementById(elId);

            that.isScrollDisabled = true;
            window.setTimeout(function(){

                el.scrollIntoView();

                //if it is from click, move el backward with negative offset if so that scorestrip and global nav won't cover the banner ad
                if (fromClick) {
                    var offset = offset || that.getNavHeightOffset();
                    that.updateElScrollTop(el, -offset);
                }

                that.isScrollDisabled = false;

            }, timer);

        },
        getElementFromPoint: function() {
            var that = this;
            var yPoint = that.viewports.winH / 2;
            var xPoint = that.viewports.winW / 2;

            return document.elementFromPoint(xPoint, yPoint);
        },

        inRegion: function(parentEl, childEl) {
            return (childEl === parentEl) ? false : parentEl.contains(childEl);
        },
        isInStoryRegion: function() {

            var that = this;

            var el = that.getElementFromPoint();

            for (var i = 0, l = that.articleElements.length; i < l; i++) {

                var articleEl = that.articleElements[i];

                if (articleEl !== null && !that.isScrollDisabled && storyInView.getCurrentIndex() !== i && that.inRegion(articleEl, el)) {

                    storyInView.goTo(i);

                }
            }

            return storyInView.getCurrentIndex();

        },

        startScroll: function() {

            var that = this,
                didScroll = false,
            //cashed position Y position before the scroll
                cachedScrollYpos =  window.pageYOffset,
                chkViewPort = that.viewports.getViewPort();

            window.addEventListener('scroll',function() {

                var scrollYpos = window.pageYOffset,
                    scrollDirection = (scrollYpos > cachedScrollYpos)  ? 'down' : 'up',
                    callbackLen = that.callbackQueue.length;

                if (callbackLen > 0) {

                    for (var i = 0; i < callbackLen; i++) {

                        that.callbackQueue[i](chkViewPort, scrollYpos, scrollDirection);
                    }
                }

                cachedScrollYpos = scrollYpos;

                didScroll = true;

            });

            setInterval(function() {
                //only run if scroll is true
                //http://ejohn.org/blog/learning-from-twitter/
                if ( didScroll ) {
                    didScroll = false;
                    that.isInStoryRegion();
                }
            }, 100);

        }

    };

    storyScroll.init();

    return storyScroll;

}]);



// WEBPACK FOOTER //
// ./assets/components/threethings/factories/storyScroll.js